import React, { Component, useState } from 'react'
import PropTypes from 'prop-types'
import { Breadcrumbs, SectionLink } from 'Blocks'
import { PAGE_CONTEXT as p } from 'Constants'
import config from 'Config'
import skins from '../skins'
import { skin, sendArticleGA, path } from 'Utils'
import { HubTargetWrapper } from '../components'

const Large = ({ params, className, location, screenType, data }) => {
  const [isIOS, setIsIOS] = useState(false);
  React.useEffect(() => {
    if (data) {
    //   sendArticleGA({ article: data.content })
    }
  }, [data])

  React.useEffect(() => {
    let isIos = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
    setIsIOS(isIos);
    if(config.theme && config.theme === 'v1') {
      const ele = document.querySelector('.global-header');
      if(ele) {
        ele.classList.remove('active');
        if(config.name === 'sb') {
          ele.classList.add('fixed');
        }
      }
    }
  }, [])

  const hub = data.content

  return (
    <HubTargetWrapper hub={hub} screenType={screenType} isIOS={isIOS} location={location} />
  )
}

Large.propTypes = {
  className: PropTypes.string,
  screenType: PropTypes.string,
  data: PropTypes.shape({
    content: PropTypes.any
  }),
  location: PropTypes.object,
  params: PropTypes.object
}

export default skin(Large, skins)
